import { useState } from 'react';
import { InfoWindow } from '@vis.gl/react-google-maps';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';

const CustomeInfoWindow = ({ point, hideInfoWindow, copyButtonText, copyToClipboard }) => {
	const [showAddCoordinateDropdown, setShowAddCoordinateDropdown] = useState(false)
	const hasPrices = (point) => {
		return point.price.value || point.price.gravity || point.price.bsw
	}

	return (
		<InfoWindow
			position={point}
			className="info-window"
			style={{ "display": 'flex', "flexDirection": 'column' }}
			onCloseClick={hideInfoWindow}
			pixelOffset={[0, -25]}
			options={{ disableAutoPan: true }}
		>
			<>
				{
					!point.isMarket ? (
						<div>
							<h1 style={{ fontWeight: 'bold' }}>{point.lease} {point.producer ? "(" + point.producer + ")" : ''}</h1>
							{point.api !== null && <div style={{ display: 'flex', marginTop: 5 }}><h2 style={{ fontWeight: '400' }}>api: </h2><span style={{ marginLeft: '5px' }}>{point.api}</span></div>}
							{point.api !== null && <div style={{ display: 'flex' }}><h2 style={{ fontWeight: '400' }}>bsw: </h2><span style={{ marginLeft: '5px' }}>{point.bsw}</span></div>}
							{point.api !== null && <div style={{ display: 'flex' }}><h2 style={{ fontWeight: '400' }}>bpd: </h2><span style={{ marginLeft: '5px' }}>{point.bpd}</span></div>}
							<div style={{ display: 'flex', marginTop: 5 }}><h2 style={{ fontWeight: '400' }}>
								{point.lease === 'Coordinate 1' || point.lease === 'Coordinate 2' ? "Location:" : "Coordinates:"}</h2><span style={{ marginLeft: '5px' }}>{`${point.lat}, ${point.lng}`}</span></div>
						</div>
					)
						: (
							<div>
								<h1 style={{ fontWeight: 'bold' }}>{point.market}</h1>
								<h2>Station: {point.station}</h2>
								<h2>Coordinates: {`${point.lat}, ${point.lng}`}</h2>
								{/* Fixed: Added safety checks for arrays and first elements */}
								{point.price?.value && point.price.value.length > 0 && point.price.value[0]?.formula && <h2>Formula: {point.price.value[0].formula}</h2>}
								{point.price?.gravity && point.price.gravity.length > 0 && point.price.gravity[0]?.formula && <h2>Formula: {point.price.gravity[0].formula}</h2>}
								{point.price?.bsw && point.price.bsw.length > 0 && point.price.bsw[0]?.formula && <h2>Formula: {point.price.bsw[0].formula}</h2>}
								<div style={{ display: 'flex', cursor: `${hasPrices(point) ? 'pointer' : 'auto'}`, width: 'fit-content' }} onClick={() => setShowAddCoordinateDropdown(!showAddCoordinateDropdown)}>
									<h2>Prices</h2>
									{
										hasPrices(point) ? (
											<span style={{ position: "relative", "left": 3, top: 1 }}>
												<FontAwesomeIcon icon={showAddCoordinateDropdown ? faCaretUp : faCaretDown} />
											</span>
										) : (
											<span> : (No prices set for the station)</span>
										)
									}
								</div>
								{
									showAddCoordinateDropdown && (
										<ul style={{ listStyle: 'unset' }}>
											{
												point.price?.value && point.price.value.map((basePrice, index) => (
													<div key={`value-${index}`}>
														<li><strong>Base</strong></li>
														<ul style={{ listStyle: 'circle' }}>
															{basePrice.discount && <li>Discount: {basePrice.discount}</li>}
															{basePrice.discountPercentage && <li>Discount Percentage: {basePrice.discountPercentage}%</li>}
															<li>Price: {basePrice.value}</li>
														</ul>
													</div>
												))
											}
											{
												point.price?.gravity && point.price.gravity.map((gravityPrice, index) => (
													<div key={`gravity-${index}`}>
														<li><strong>Gravity {gravityPrice.low}-{gravityPrice.high}</strong></li>
														<ul style={{ listStyle: 'circle' }}>
															{gravityPrice.discount && <li>Discount: {gravityPrice.discount}</li>}
															{gravityPrice.discountPercentage && <li>Discount Percentage: {gravityPrice.discountPercentage}</li>}
															<li>Price: {gravityPrice.value}</li>
														</ul>
													</div>
												))
											}
											{
												point.price?.bsw && point.price.bsw.map((bswPrice, index) => (
													<div key={`bsw-${index}`}>
														<li><strong>BSW {bswPrice.low}-{bswPrice.high}</strong></li>
														<ul style={{ listStyle: 'circle' }}>
															{bswPrice.discount && <li>Discount: {bswPrice.discount}</li>}
															{bswPrice.discountPercentage && <li>Discount Percentage: {bswPrice.discountPercentage}</li>}
															<li>Price: {bswPrice.value}</li>
														</ul>
													</div>
												))
											}

										</ul>
									)
								}
							</div>
						)
				}

				<button 
					className='calculateButton'
					style={
						{ border: "1px solid grey",
						backgroundColor: "lightblue",
						padding: 3,
						alignSelf: "end",
						width: "fit-content",
						fontSize: 10,
						marginTop: 5,
						color: 'black' }} onClick={() => copyToClipboard(point)}>
					{copyButtonText}
				</button>

			</>
		</InfoWindow>
	)
}

export default CustomeInfoWindow